import PropTypes from "prop-types";

export const pricegroupPropTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    created: PropTypes.string,
    fee_hour: PropTypes.string,
    fee_day: PropTypes.string,
    fee_week: PropTypes.string,
    fee_month: PropTypes.string,
    fee_quarter: PropTypes.string,
    fee_year: PropTypes.string,
    fee_ten_years: PropTypes.string,
    modified: PropTypes.string,
};
